import React from "react";

export default function Marquee() {
  const phrase = "BAKED FRESH IN VADODARA \u2014 WHOLE ROMAN PIZZAS \u2014 72 HOUR BIGA DOUGH \u2014 GOTRI SEVASI ROAD \u2014 ";
  const text = phrase.repeat(4);
  return (
    <section
      className="bg-biga-cream border-y-2 border-biga-ink py-5 overflow-hidden"
      data-testid="marquee"
      aria-label="Brand marquee"
    >
      <div className="marquee-track">
        <span className="font-display italic font-black text-4xl sm:text-6xl text-biga-orange pr-4">
          {text}
        </span>
        <span className="font-display italic font-black text-4xl sm:text-6xl text-biga-orange pr-4">
          {text}
        </span>
      </div>
    </section>
  );
}
